import React, { FC } from 'react'

const RegenerateOutlinedIcon: FC<{
    className?: string
}> = ({ className = '' }) => (
    <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M0.993563 11.9992V11.1825H3.52194L2.66118 10.3316C2.03617 9.70655 1.58101 9.02872 1.29573 8.29808C1.01044 7.56853 0.867798 6.82646 0.867798 6.07187C0.867798 4.75977 1.24183 3.57289 1.98989 2.51123C2.73795 1.44957 3.72502 0.691167 4.9511 0.236015V1.10331C3.96022 1.5198 3.16806 2.17967 2.57462 3.08289C1.98118 3.98612 1.68446 4.98244 1.68446 6.07187C1.68446 6.73717 1.8105 7.38233 2.06257 8.00735C2.31519 8.63346 2.70719 9.21247 3.23856 9.74438L4.07155 10.5766V8.10453H4.88821V12L0.993563 11.9992ZM9.0344 11.764V10.8967C10.0253 10.4802 10.8174 9.82033 11.4109 8.91711C12.0043 8.01388 12.301 7.01756 12.301 5.92813C12.301 5.26283 12.175 4.61767 11.9229 3.99265C11.6703 3.36654 11.2783 2.78753 10.7469 2.25561L9.91394 1.42344V3.89547H9.09728V0H12.9927V0.81666H10.4636L11.3243 1.66844C11.9493 2.29345 12.4045 2.97128 12.6898 3.70192C12.9751 4.43147 13.1177 5.17354 13.1177 5.92813C13.1177 7.24023 12.7437 8.42711 11.9956 9.48877C11.2475 10.5504 10.2605 11.3088 9.0344 11.764Z"
        />
    </svg>
)

export default RegenerateOutlinedIcon
